import React from "react"
import ContactContent from "../../../modules/contacts/components/shared/contactContent/ContactContent"
import ContactContentStyle from "../../../modules/contacts/components/shared/contactContent/ContactContetStyle.module.styl"
import { Link } from "gatsby"
import ContactWrapperStyle from "../../../modules/contacts/components/shared/contactWrapper/ContactWrapperStyle.module.styl"
import translate, { keys } from "../../../translation/translator"

const FirstStepsForm = ({
  name,
  email,
  handleChangeName,
  handleChangeEmail,
  errors,
  handleSubmit,
  togglePrivacyCheck,
  privacyChecked,
  newsletterChecked,
  toggleNewsletterChecked,
  loading,
  locale,
}) => {
  return (
    <div className={ContactWrapperStyle.wrapper}>
      <h2>{translate(keys.FIRST_STEPS_FORM_FS, locale)}</h2>
      <ContactContent>
        {loading === true ? (
          <div className="loader" />
        ) : (
          <form onSubmit={handleSubmit} name="contact" method="POST">
            <input type="hidden" name="form-name" value="contact" />
            <label className={ContactContentStyle.label} htmlFor="FNAME">
              {translate(keys.FIRST_STEPS_FORM_UR_NAME, locale)}
              <input
                required
                name="FNAME"
                value={name}
                onChange={handleChangeName}
                type="text"
                placeholder={translate(keys.FIRST_STEPS_FORM_UR_NAME, locale)}
              />
            </label>
            <span className="contact-error"> {errors.name && errors.name}</span>
            <label className={ContactContentStyle.label} htmlFor="EMAIL">
              {translate(keys.FIRST_STEPS_FORM_UR_EMAIL, locale)}
              <input
                required
                name="EMAIL"
                value={email}
                onChange={handleChangeEmail}
                type="text"
                placeholder={translate(keys.FIRST_STEPS_FORM_UR_EMAIL, locale)}
              />
            </label>
            <span className="contact-error">
              {" "}
              {errors.email && errors.email}
            </span>
            <label htmlFor="checkbox" className="privacy-checkbox">
              <input
                required
                id="checkbox"
                value={privacyChecked}
                onClick={togglePrivacyCheck}
                type="checkbox"
              />
              {translate(keys.FIRST_STEPS_FORM_READ_AND_AGREE, locale)}{" "}
              <Link to="/terms">
                {translate(keys.FIRST_STEPS_FORM_TERMS, locale)}
              </Link>{" "}
              {translate(keys.FIRST_STEPS_FORM_AND, locale)}{" "}
              <Link to="/privacy-policy">
                {translate(keys.FIRST_STEPS_FORM_PRIVACY_POLICY, locale)}
              </Link>
            </label>
            <span className="contact-error">
              {errors.privacy && errors.privacy}
            </span>
            <label htmlFor="checkboxNewsletter" className="privacy-checkbox">
              <input
                required
                id="checkboxNewsletter"
                value={newsletterChecked}
                onClick={toggleNewsletterChecked}
                type="checkbox"
              />
              {translate(keys.FIRST_STEPS_FORM_YES_SUBSCRIBE, locale)}
            </label>
            <button type="submit" onClick={handleSubmit}>
              {translate(keys.FIRST_STEPS_FORM_SUBMIT, locale)}
            </button>
          </form>
        )}
      </ContactContent>
    </div>
  )
}

export default FirstStepsForm
